// Display helpers. All take primitive values and return strings — no JSX, no
// React imports — so they can be reused from PDF-export or test code.

export function fmtMoney(n: number | null | undefined, opts: { decimals?: number } = {}): string {
    if (n == null || Number.isNaN(n)) return '—';
    const d = opts.decimals ?? 2;
    const abs = Math.abs(n);
    const fixed = abs.toFixed(d);
    const [i, f] = fixed.split('.');
    const grouped = i.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (n < 0 ? '-' : '') + (f ? `${grouped}.${f}` : grouped);
}

// Accounting style — negatives in parentheses, no leading minus.
export function fmtAccounting(n: number | null | undefined, opts: { decimals?: number } = {}): string {
    if (n == null || Number.isNaN(n)) return '—';
    if (n < 0) return `(${fmtMoney(-n, opts)})`;
    return fmtMoney(n, opts);
}

// Compact human date — date-only when the time component is midnight.
export function fmtDate(d: string | Date | null | undefined, lng = 'en'): string {
    if (!d) return '—';
    const dt = d instanceof Date ? d : new Date(d);
    if (Number.isNaN(dt.getTime())) return '—';
    return new Intl.DateTimeFormat(lng === 'ar' ? 'ar-EG' : 'en-GB', {
        year: 'numeric', month: 'short', day: '2-digit',
    }).format(dt);
}

export function fmtDateTime(d: string | Date | null | undefined, lng = 'en'): string {
    if (!d) return '—';
    const dt = d instanceof Date ? d : new Date(d);
    if (Number.isNaN(dt.getTime())) return '—';
    return new Intl.DateTimeFormat(lng === 'ar' ? 'ar-EG' : 'en-GB', {
        year: 'numeric', month: 'short', day: '2-digit',
        hour: '2-digit', minute: '2-digit',
    }).format(dt);
}

export function fmtFileSize(bytes: number): string {
    if (bytes < 1024) return `${bytes} B`;
    const kb = bytes / 1024;
    if (kb < 1024) return `${kb.toFixed(1)} KB`;
    return `${(kb / 1024).toFixed(1)} MB`;
}
